const CUSTOM_COLOR_PICKER_MODAL_ID = "customColorPicker";
export {
  CUSTOM_COLOR_PICKER_MODAL_ID
};
//# sourceMappingURL=constants.js.map
